import {
  Location,
  type LOCATION_TYPE_TITLE
} from '../../../types/models/Location.model'
import { isNonEmptyString, isNumber } from '../../../utils/checks'
import getCustomRadiusFromLocation from './getCustomRadiusFromLocation'
import { SearchRadiusInMiles as RadiusInMiles } from '@/constants/searchRadius'
import { DEFAULT_AROUND_RADIUS_IN_MILES } from '@/domain/filterOptions/constants'

export type LocationRadiusType = Pick<Location, 'type' | 'miRadius'>

export const getLocationRadius = (
  location: LocationRadiusType,
  SearchRadiusInMiles: typeof RadiusInMiles = RadiusInMiles
): number => {
  const customRadiusFromLocation = getCustomRadiusFromLocation(location)

  if (isNumber(customRadiusFromLocation) && customRadiusFromLocation > 0) {
    return customRadiusFromLocation
  }

  if (!isNonEmptyString(location?.type)) {
    return DEFAULT_AROUND_RADIUS_IN_MILES
  }

  const customRadiusFromLocationType =
    SearchRadiusInMiles[location?.type.toUpperCase() as LOCATION_TYPE_TITLE]
  return customRadiusFromLocationType || DEFAULT_AROUND_RADIUS_IN_MILES
}
